module.exports = __webpack_public_path__ + "static/media/Kopie von RR-LOGO 1.bd077f2b.png";